import React from 'react';
import { Box } from '@drone-js/core';

interface Props {
    end?: string;
    top?: string;
    start?: string;
    elementName: string;
}

const RibbonContainer: React.FC<React.PropsWithChildren<Props>> = (props) => {
    return (
        <React.Suspense fallback={null}>
            <Box position="absolute" start={props.start} top={props.top} end={props.end} data-testid={props.elementName}>
                {props.children}
            </Box>
        </React.Suspense>
    );
};

RibbonContainer.displayName = 'RibbonContainer';

export default RibbonContainer;
